import { apiClient } from './client';
import {
  PartVendor,
  PartVendorAttachmentKind,
  PartVendorPayload,
  PartVendorTradeHistory,
} from '../types/partVendor';

export async function fetchPartVendors(keyword?: string): Promise<PartVendor[]> {
  const { data } = await apiClient.get<PartVendor[]>('/part-vendors', {
    params: keyword?.trim() ? { q: keyword.trim() } : undefined,
  });
  return data;
}

export async function fetchPartVendor(vendorId: number): Promise<PartVendor> {
  const { data } = await apiClient.get<PartVendor>(`/part-vendors/${vendorId}`);
  return data;
}

export async function createPartVendor(payload: PartVendorPayload): Promise<PartVendor> {
  const { data } = await apiClient.post<PartVendor>('/part-vendors', payload);
  return data;
}

export async function updatePartVendor(
  vendorId: number,
  payload: Partial<PartVendorPayload>
): Promise<PartVendor> {
  const { data } = await apiClient.patch<PartVendor>(`/part-vendors/${vendorId}`, payload);
  return data;
}

export async function deletePartVendor(vendorId: number): Promise<void> {
  await apiClient.delete(`/part-vendors/${vendorId}`);
}

export async function uploadPartVendorAttachment(
  vendorId: number,
  file: File,
  kind: PartVendorAttachmentKind = 'OTHER'
): Promise<PartVendor> {
  const body = new FormData();
  body.append('file', file);
  const { data } = await apiClient.post<PartVendor>(
    `/part-vendors/${vendorId}/attachments`,
    body,
    {
      params: { kind },
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
  return data;
}

export async function deletePartVendorAttachment(
  vendorId: number,
  attachmentId: number
): Promise<void> {
  await apiClient.delete(`/part-vendors/${vendorId}/attachments/${attachmentId}`);
}

export async function downloadPartVendorAttachment(
  vendorId: number,
  attachmentId: number
): Promise<Blob> {
  const { data } = await apiClient.get<Blob>(
    `/part-vendors/${vendorId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  return data;
}

export async function fetchPartVendorTradeHistory(
  vendorId: number
): Promise<PartVendorTradeHistory[]> {
  const { data } = await apiClient.get<PartVendorTradeHistory[]>(
    `/part-vendors/${vendorId}/trade-history`
  );
  return data;
}
